import { IPlayer } from "../../interfaces";

const mapTeamPlayers = (players: any, playersGameInfo: any): IPlayer[] => {

	const playersMapped: IPlayer[] = players.map((player: IPlayer) => ({
		color: player.color,
		fullName: player.fullName,
		nickname: player.nickname,
		email: player.email,
		profileIcon: player.image,
		isReady: playersGameInfo[player.email].status,
	}));

	return playersMapped;
};

export default mapTeamPlayers;